<template>
  <div class="flex mt-8">
    <base-radio class="ml-2"
                :value="true"
                :model="isOnline"
                id="online"
                @input="onSelected"
                name="operatorStatus"
    >
      <div class="flex items-center">
        <span class="ml-1">Online</span>
        <vs-icon icon="cloud_done" size="1.3rem" class="ml-1 mb-px"></vs-icon>
      </div>
    </base-radio>

    <base-radio :value="false"
                :model="isOnline"
                id="offline"
                @input="onSelected"
                class="ml-20"
                name="operatorStatus"
    >
      <div class="flex items-center">
        <span class="ml-1">Offline</span>
        <vs-icon icon="cloud_off" size="1.3rem" class="ml-1 mb-px"></vs-icon>
      </div>
    </base-radio>
  </div>
</template>

<script>
import { CONDITION_CASES } from '@/store/constants'
import conditionUtils from '@/utils/condition.utils'

export default {
  name: 'OperatorStatusEditor',

  props: {
    isOnline: {
      type: Boolean,
      required: true
    }
  },

  methods: {
    onSelected(value) {
      this.$emit('condition-change', conditionUtils.createConditionJson(CONDITION_CASES.OPERATOR_AVAILABLE, value))
    }
  }
}
</script>
